import { render, staticRenderFns } from "./pie-chart.vue?vue&type=template&id=d801d68c&scoped=true&"
import script from "./pie-chart.vue?vue&type=script&lang=ts&"
export * from "./pie-chart.vue?vue&type=script&lang=ts&"
import style0 from "./pie-chart.vue?vue&type=style&index=0&id=d801d68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d801d68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
